<div
    class="relative grow overflow-y-auto"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading()}">
    @if (loading()) {
        <div class="absolute flex left-1/2 top-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
        <div class="px-10 py-4 border-2 rounded-md space-y-2">
            <div class="text-lg font-semibold mb-2">
                Unesite matične brojeve radnika za koje je potrebno deaktivirati postojeću i generirati novu Valamartist digitalnu karticu
            </div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-52">
                <mat-select placeholder="Mbrad tip" [value]="selectedMbradType()" (selectionChange)="selectMbradType($event)">
                    @for (type of mbradTypes; track type) {
                        <mat-option [value]="type">{{ type }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <div class="flex gap-5">
                <button (click)="openText()" class="valben-button">Unesi matične brojeve tekstom</button>
                <ng-template #textDialog>
                    <button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
                        <mat-icon>close</mat-icon>
                    </button>

                    <h2 mat-dialog-title class="text-lg font-semibold pr-10">Zalijepi Mbrad brojeve zaposlenika</h2>

                    <mat-dialog-content>
                        <textarea
                            class="w-full box-border resize-none border rounded-md p-2 text-md focus:outline-none"
                            placeholder="1234, 123, 12345"
                            [(ngModel)]="textMbrads"
                            rows="7">
                        </textarea>

                        @if (otherTypeErr() !== "") {
                            <p><b>Mbradovi ne postoje za odabrani tip {{this.selectedMbradType()}}:</b></p>
                            <p>{{ otherTypeErr() }}</p>
                        }

                        <div class="flex justify-end">
                            <button (click)="confirmText()" class="valben-button">
                                {{ confirmAgain ? 'Spremi samo ispravne' : 'Spremi' }}
                            </button>
                        </div>
                    </mat-dialog-content>
                </ng-template>
            </div>

            <ng-template #employeeOption let-option>
                <p>{{ option.data.fullName }} ({{ option.data.mbrad }})</p>
            </ng-template>

            <valben-searchable-select
                class="w-full"
                placeholder="Mbrad"
                [multiple]="true"
                [options]="employeeOptions()"
                [(values)]="selectedEmployees"
                [optionTemplate]="employeeOption"
                [maxSelectedLabels]="10"
                [pinSelected]="true"
                [virtualScroll]="true"
                [virtualItemSize]="48"
                [virtualHeight]="480"
                [virtualMinBuffer]="480"
                [virtualMaxBuffer]="960"
                [panelClass]="['valben-searchable-select-panel', 'valben-employee-select-panel']" />
        </div>

        <div class="flex gap-4 justify-end items-center select-none">
            <button class="text-lg valben-button" (click)="generate()">Generiraj</button>
        </div>
    </div>
</div>

